module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/main-visual-538575961e67a9b4dc189e31138e0b74.jpg";